import { AdditionalExpense } from '../models/document';

export const createAdditionalExpense = (data?: AdditionalExpense) => ({
  id: Math.random().toString(),
  description: data?.description ?? '',
  expense: data?.expense,
});
